import tw, { styled } from 'twin.macro';
import Button from '@/components/Forms/components/FormButton/FormButton';
import Input from '../components/Input/Input';

export const StyledButton = styled(Button)`
  ${tw`h-6`}
  ${tw`lg:col-start-3`}
  ${tw`lg:rounded-l-none`}
  ${tw`py-0 px-[22px]`}
  ${tw`overflow-hidden`}
`;

export const StyledInput = styled(Input)`
  ${tw`lg:col-span-2`}

  input {
    ${tw`h-6`}
    ${tw`lg:rounded-r-none lg:rounded-l-lg`}
  }

  label {
    display: none;
  }
`;

export const StyledFormRow = styled.div`
  ${tw`mb-[1rem]`}
  ${tw`grid gap-2 lg:grid-cols-3 lg:gap-0`}
`;
